var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { organizationTypeEntityName, } from '../../../../backend/config/classifiers/OrganizationTypeClassifier/shared';
import { systemStatuses } from '../../../../backend/features/accounts/shared';
import { groupEntityName } from '../../../../backend/features/groups/shared';
import { organizationEntityName } from '../../../../backend/features/organizations/shared';
import { defaultOrgPermissions, getGroupFilter, requireAnyOrgPermission, requireAnySystemPermission, } from '../../../../backend/features/permissions/shared';
import { StorageClient } from '@juvare/platform-sdk-js/StorageClient';
import { buildPublicDataValueProvider } from '@juvare/platform-sdk-react/ui/features/classifiers';
export function buildContactManagementFormValueProviders(t, settings, userState, appName, additionalPermissions) {
    return [
        ...(settings
            ? [
                {
                    type: 'contactManagement.orgRole',
                    label: 'Organization Role',
                    getValues: () => Promise.resolve(Object.entries(settings.orgRoleMap).map(([value, role]) => ({
                        value,
                        label: role.label,
                    }))),
                },
            ]
            : []),
        {
            type: 'contactManagement.orgPermission',
            label: 'Organization Permission',
            getValues: () => Promise.resolve([
                // TODO Fix defect CNEO-4609 here..., change method to hook, get org permissions from setting, using useSelector(getSettings)...
                ...Object.entries(defaultOrgPermissions).map(([value, role]) => ({
                    value: value,
                    label: role.label,
                })),
                ...(additionalPermissions !== null && additionalPermissions !== void 0 ? additionalPermissions : []),
            ]),
        },
        ...(settings
            ? [
                {
                    type: 'contactManagement.systemRole',
                    label: 'System Role',
                    getValues: () => {
                        if (settings.systemRoleMap) {
                            return Promise.resolve(Object.entries(settings.systemRoleMap)
                                .sort(([, aRole], [, bRole]) => bRole.level - aRole.level)
                                .map(([value, role]) => ({
                                value: value,
                                label: role.label,
                            })));
                        }
                        return Promise.resolve([]);
                    },
                },
            ]
            : []),
        {
            type: 'contactManagement.systemStatus',
            label: 'System Status',
            getValues: () => {
                if (userState) {
                    return Promise.resolve(systemStatuses
                        .filter((status) => {
                        if (requireAnySystemPermission(userState, 'manage-accounts')) {
                            return ['active', 'inactive', 'closed', 'deleted'].includes(status);
                        }
                        if (requireAnyOrgPermission(userState, 'manage-members')) {
                            return ['active', 'inactive', 'closed'].includes(status);
                        }
                        return ['active', 'inactive'].includes(status);
                    })
                        .map((value) => ({
                        value,
                        label: t(`panels.accounts.status.${value}`),
                    })));
                }
                return Promise.resolve([]);
            },
        },
        {
            type: 'contactManagement.group',
            label: 'Group',
            getValues: () => __awaiter(this, void 0, void 0, function* () {
                if (userState) {
                    const groupStorage = new StorageClient(groupEntityName);
                    const groupFilter = [...getGroupFilter(userState)];
                    const groups = yield groupStorage.list({ filter: groupFilter, orderBy: [{ column: 'name' }] });
                    return groups.rows.map((group) => ({ label: group.columns.name, value: group.id }));
                }
                return [];
            }),
        },
        buildPublicDataValueProvider({ appName, classifierName: 'pagerCarrier', label: 'Pager Carrier' }),
        {
            type: 'contactManagement.organizationTypes',
            label: 'Organizations Types',
            getValues: () => __awaiter(this, void 0, void 0, function* () {
                const organizationStorage = new StorageClient(organizationTypeEntityName);
                const organizationTypes = yield organizationStorage.list({
                    filter: [
                        {
                            column: 'status',
                            op: '=',
                            value: 'active',
                        },
                    ],
                    orderBy: [{ column: 'name' }],
                });
                return organizationTypes.rows.map((organizationType) => ({
                    label: organizationType.columns.name,
                    value: organizationType.columns.name,
                }));
            }),
        },
        {
            type: 'contactManagement.organizationsByType',
            label: 'Organizations by Type',
            getValues: (type) => __awaiter(this, void 0, void 0, function* () {
                if (userState && type) {
                    const organizationStorage = new StorageClient(organizationEntityName);
                    const organizations = yield organizationStorage.list({
                        filter: [
                            {
                                column: 'type',
                                op: '=',
                                value: type,
                            },
                        ],
                        orderBy: [{ column: 'name' }],
                    });
                    return organizations.rows.map((organization) => ({ label: organization.columns.name, value: organization.id }));
                }
                return [];
            }),
        },
    ];
}
